import { render, staticRenderFns } from "./ListForms.vue?vue&type=template&id=1f4ca79c&scoped=true&"
import script from "./ListForms.vue?vue&type=script&lang=js&"
export * from "./ListForms.vue?vue&type=script&lang=js&"
import style0 from "./ListForms.vue?vue&type=style&index=0&id=1f4ca79c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ca79c",
  null
  
)

export default component.exports